module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.data,
    attrs: {
      "id": "aye",
      "width": "162",
      "height": "454",
      "viewBox": "0 0 162 454"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "orb_path",
      "d": "M73 147c0 8.28 6.72 15 15 15 8.28 0 15-6.72 15-15 0-8.28-6.72-15-15-15-8.28 0-15 6.72-15 15z"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "orb_filter",
      "width": "136.7%",
      "height": "136.7%",
      "x": "-18.3%",
      "y": "-18.3%",
      "filterUnits": "objectBoundingBox"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "5",
      "in": "SourceAlpha",
      "result": "shadowBlurInner1"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dx": "1",
      "dy": "1",
      "in": "shadowBlurInner1",
      "result": "shadowOffsetInner1"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "shadowOffsetInner1",
      "in2": "SourceAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1",
      "result": "shadowInnerInner1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
      "in": "shadowInnerInner1"
    }
  })], 1)]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_left_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_left_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_left_arm_3",
      "fill": "#D8D8D8",
      "d": "M120.5 292c-6.92 0-12.5-5.6-12.5-12.53v-74.94c0-6.93 5.58-12.53 12.5-12.53s12.5 5.6 12.5 12.53v74.94c0 6.93-5.67 12.53-12.5 12.53z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_left_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_left_hand_2",
      "fill": "#BCC1BC",
      "d": "M132.96 279c1.6 5.1 5 15 5.02 17 .03 2-4.2 2.34-5.55-1.73-1.35-4.06-2.03-6.27-2.43-7.27-.27.65 0 15 0 17 0 1.98-4.97 2.07-4.97 0 0-2.1 0-14.97-.03-16-.03-1.03-1.06-1.04-1 0 .06 1.04-.07 14.87-.07 17 0 2.1-4.93 2.1-4.93 0v-17c0-.9-1-.95-1 0v16c0 2.02-5 2.05-5 0 .02-2.08 0-14.96 0-16 0-1.04-1-1.22-1 0v12c0 1.9-4.02 2.05-4 0 .02-2.05 0-15.05 0-21 0-5.95 22-9.43 24.96 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_hand_1",
      "fill": "#B3B9B3",
      "d": "M120.5 292c-6.9 0-12.5-5.6-12.5-12.5s5.6-12.5 12.5-12.5 12.5 5.6 12.5 12.5-5.6 12.5-12.5 12.5z"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_arm_2",
      "fill": "#D8D8D8",
      "d": "M120.5 217c-6.92 0-12.5-5.6-12.5-12.53v-74.94c0-6.93 5.58-12.53 12.5-12.53s12.5 5.6 12.5 12.53v74.94c0 6.93-5.67 12.53-12.5 12.53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_arm_1",
      "fill": "#BCC1BC",
      "d": "M108 204.5c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5-5.6-12.5-12.5-12.5-12.5 5.6-12.5 12.5z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_4",
      "fill": "#BCC1BC",
      "d": "M102.3 415.05c3.3 10.67 21.6 22.45 26.18 23.12 3.23.5 3.83 7.37-1.05 7.54-7.3.27-40.17.35-49.04.27-1.22 0-2.27-1.1-2.35-2.46-.45-6.85 2.03-25.32 3.24-27.86 1.42-3.05 22.03-3.73 23-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_3",
      "fill": "#D8D8D8",
      "d": "M91 432c8.3 0 15-7.3 15-16.3v-97.4c0-9-6.7-16.3-15-16.3s-15 7.3-15 16.3v97.4c0 9 6.7 16.3 15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_2",
      "fill": "#D8D8D8",
      "d": "M91 332c8.3 0 15-7.3 15-16.3v-97.4c0-9-6.7-16.3-15-16.3s-15 7.3-15 16.3v97.4c0 9 6.7 16.3 15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_1",
      "fill": "#BCC1BC",
      "d": "M76 317c0 8.28 6.72 15 15 15 8.28 0 15-6.72 15-15 0-8.28-6.72-15-15-15-8.28 0-15 6.72-15 15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_body_main",
      "fill": "#E2E2E2",
      "d": "M120.48 121.17c-16.98-17.2-75.3-17.53-88.9-1.12C16.96 137.58 30.84 228 76.03 228c45.2 0 58.93-92.17 44.45-106.83z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_orb_offset"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#777",
      "xlink:href": "#orb_path"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "fill": "#000",
      "filter": "url(#orb_filter)",
      "xlink:href": "#orb_path"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_orb",
      "fill": "#D0021B",
      "d": "M75 147c0 7.18 5.37 13 12 13s12-5.82 12-13-5.37-13-12-13-12 5.82-12 13z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_orb_glare_2",
      "fill": "#FFF",
      "d": "M93.5 142c-.74.5-.95 1.5-.45 2.25v.02c.66.94.97 1.85.95 2.73-.02.88-.34 1.78-.96 2.7-.5.77-.3 1.8.46 2.3.77.5 1.8.3 2.32-.46.05-.07.1-.14.12-.2.7-1.48 1.06-2.9 1.06-4.3s-.35-2.87-1.07-4.37c-.4-.83-1.4-1.18-2.22-.8-.06.05-.13.1-.2.13z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_orb_glare_1",
      "fill": "#FFF",
      "d": "M92.5 141c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_4",
      "fill": "#BCC1BC",
      "d": "M63.3 415.05c3.3 10.67 21.6 22.45 26.18 23.12 3.23.5 3.83 7.37-1.06 7.54-7.3.27-40.16.35-49.03.27-1.22 0-2.27-1.1-2.35-2.46-.45-6.85 2.03-25.32 3.24-27.86 1.42-3.05 22.03-3.73 23-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_3",
      "fill": "#EFEFEF",
      "d": "M53 432c8.3 0 15-7.3 15-16.3v-97.4c0-9-6.7-16.3-15-16.3s-15 7.3-15 16.3v97.4c0 9 6.7 16.3 15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_2",
      "fill": "#EFEFEF",
      "d": "M53 332c8.3 0 15-7.3 15-16.3v-97.4c0-9-6.7-16.3-15-16.3s-15 7.3-15 16.3v97.4c0 9 6.7 16.3 15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_1",
      "fill": "#BCC1BC",
      "d": "M38 317c0 8.28 6.72 15 15 15 8.28 0 15-6.72 15-15 0-8.28-6.72-15-15-15-8.28 0-15 6.72-15 15z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_right_hand_2",
      "fill": "#BCC1BC",
      "d": "M45.97 278.84c1.6 5.1 5 15 5.03 17 .02 2-4.2 2.34-5.55-1.73-1.35-4.06-2.04-6.26-2.43-7.26-.27.64 0 15 0 17 0 1.98-4.98 2.06-4.98 0 0-2.1 0-14.98-.02-16-.03-1.03-1.07-1.05-1 0 .06 1.04-.07 14.87-.07 17 0 2.1-4.93 2.1-4.93 0v-17c0-.9-1-.95-1 0v16c0 2.02-5 2.05-5 0 .02-2.08 0-14.96 0-16 0-1.04-1-1.22-1 0v12c0 1.9-4.03 2.05-4 0 .02-2.05 0-15.06 0-21 0-5.95 22-9.43 24.95 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_hand_1",
      "fill": "#B2B2B2",
      "d": "M33.5 292c-6.9 0-12.5-5.6-12.5-12.5S26.6 267 33.5 267 46 272.6 46 279.5 40.4 292 33.5 292z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_arm_3",
      "fill": "#EFEFEF",
      "d": "M33.5 292c6.92 0 12.5-5.6 12.5-12.53v-74.94C46 197.6 40.42 192 33.5 192S21 197.6 21 204.53v74.94C21 286.4 26.58 292 33.5 292z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_arm_2",
      "fill": "#EFEFEF",
      "d": "M33.5 217c6.92 0 12.5-5.6 12.5-12.53v-74.94C46 122.6 40.42 117 33.5 117S21 122.6 21 129.53v74.94C21 211.4 26.58 217 33.5 217z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_arm_1",
      "fill": "#BCC1BC",
      "d": "M21 204.5c0 6.9 5.6 12.5 12.5 12.5S46 211.4 46 204.5 40.4 192 33.5 192 21 197.6 21 204.5z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_head_3",
      "fill": "#EFEFEF",
      "d": "M60.64 103h25.72C108.3 103 126 83.96 126 60.54 126 37.04 108.3 18 86.36 18H60.64C38.7 18 21 37.04 21 60.46 21 83.96 38.78 103 60.64 103z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_head_2",
      "fill": "#BCC1BC",
      "d": "M24 45c-4.22 6.78-3.37 21.98-1 29 1.16.1 8.9.6 8.97-14.73C32.05 44.52 24.93 45.1 24 45z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_head_1",
      "fill": "#777",
      "d": "M67.43 26h22.14C106.95 26 121 40.53 121 58.5v10c0 17.97-14.05 32.5-31.43 32.5H67.43C50.05 101 36 86.47 36 68.5v-10C36 40.53 50.13 26 67.43 26z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_face"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_mouth_frown",
      "fill": "#D7F4E5",
      "d": "M74.54 76.24c5.76-2.76 12.58-3.93 18.48.42 1.52 1.18 2.73-1.67 1.22-2.85-6.52-4.84-14.17-3.76-20.53-.74-1.58.75-.75 3.94.84 3.18z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_unsure",
      "fill": "#D7F4E5",
      "d": "M75.08 71.2c1.15.3 1.92 1.25 2.77 2.3.32.37.7.86 1.15.68.43-.18.76-.96 1.02-1.43.64-1.1 1.33-2 2.37-2.22 1.1-.25 2.27.3 3.23 1.1 1.04.87 2.03 2.37 3.25 2.7 1.1.3 1.56-1.4 2.23-2.3 2.17-2.98 4.9-.5 6.64 1.88.8 1.12-.44 2.85-1.25 1.75-.88-1.2-2.27-3.2-3.65-2.38-.97.57-1.36 2.32-2.27 3.07-2.67 2.22-4.77-2.7-7.14-3.34-1.38-.37-1.85 1.1-2.67 2.33-.77 1.17-1.83 1.7-2.93 1.07-1.07-.63-1.7-2.26-2.83-2.7-1.4-.56-2.65.72-2.98 2.62-.26 1.54-1.95.9-1.7-.65.52-3 2.57-5 4.76-4.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_neutral",
      "fill": "#D7F4E5",
      "d": "M96.03 72c1.3-.05 1.3 2.56 0 2.6-8.35.32-16.7.78-25.04 1.4-1.3.1-1.3-2.5 0-2.6 8.34-.63 16.68-1.1 25.03-1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_smile",
      "fill": "#D7F4E5",
      "d": "M74.68 72.65c5.74 2.57 12.53 3.66 18.42-.4 1.5-1.08 2.72 1.56 1.2 2.65-6.48 4.52-14.1 3.5-20.45.7-1.58-.7-.75-3.65.83-2.95z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_eye",
      "fill": "#D7F4E5",
      "d": "M68.5 62c1.43 0 2.5-1.03 2.5-2.2v-1.6c0-1.25-1.16-2.2-2.5-2.2-1.42 0-2.5 1.03-2.5 2.2v1.6c-.08 1.17 1.08 2.2 2.5 2.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_eye",
      "fill": "#D7F4E5",
      "d": "M99.5 62c1.43 0 2.5-1.03 2.5-2.2v-1.6c0-1.25-1.16-2.2-2.5-2.2-1.43 0-2.5 1.03-2.5 2.2v1.6c0 1.17 1.16 2.2 2.5 2.2z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cccd9d1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/aye.vue
// module id = 756
// module chunks = 1